import { useTheme } from '@emotion/react';
import { GoogleMap, useLoadScript } from '@react-google-maps/api';
import React from 'react';
import { darkStyle, lightStyle } from '../../routes/mapStyles';

const defaultCenter = {
  lat: 41.015137,
  lng: 28.97953
};

const getMapOptions = (theme) => {
  return {
    streetViewControl: true,
    scaleControl: true,
    fullscreenControl: true,
    styles: theme.palette.mode === 'dark' ? darkStyle : lightStyle,
    gestureHandling: 'greedy',
    disableDoubleClickZoom: true,
    mapTypeControl: true,
    zoomControl: true,
    clickableIcons: false
  };
};

export default function NewMap(props) {
  const { setMap, children } = props;
  const theme = useTheme();
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: 'AIzaSyAHeJFn1coDCtI52jzqJp5SwHAaeg2eEd4' // ,
  });

  const renderMap = () => {

    const loadHandler = (map) => {
      setMap(map);
    };

    return (
      <GoogleMap
        id="circle-example"
        mapContainerStyle={{
          height: '100%',
          width: '100%'
        }}
        clickableIcons={true}
        zoom={10}
        center={defaultCenter}
        options={getMapOptions(theme)}
        onLoad={loadHandler}
      >
        {children}
      </GoogleMap>
    );
  };

  if (loadError) {
    return <div>Map cannot be loaded right now, sorry.</div>;
  }

  return isLoaded ? renderMap() : <div>Loading...</div>;
}
